module.exports = __webpack_public_path__ + "static/media/services-shape-3.e4a7f5ed.svg";